<template>
	<b-row
		class="m-0"
		style="position: fixed !important; z-index: 1000; right: -1rem; top: 18rem"
	>
		<b-col cols="1">
			<b-button
				class="td-btn-teal p-0"
				style="
					width: 55px !important;
					height: 55px !important;
					border-radius: 0% 50% !important;
				"
				v-b-tooltip.left
				title="Keranjang Data"
				v-b-modal.tabel-dinamis-data-cart-modal
				:disabled="isLoadingAnOptions ||  isEditSelectedData"
				><b-icon class="text-light m-0" icon="cart" font-scale="2" />
				<span
					v-show="selectedDataListCount > 0"
					class="selected-data-list-count"
					>{{ selectedDataListCount }}</span
				>
			</b-button>
			<b-button
				class="td-btn-blue p-0"
				style="
					width: 55px !important;
					height: 55px !important;
					border-radius: 0% 50% !important;
				"
				v-b-tooltip.left
				title="Refresh Tabel Dinamis"
				@click="clearAllSelectionOptionsCache()"
				:disabled="isLoadingAnOptions || isClearAllLocalStorage || isEditSelectedData"
				><b-icon
					class="text-light m-0"
					icon="arrow-repeat"
					rotate="45"
					font-scale="2"
				/>
			</b-button>
		</b-col>
	</b-row>
</template>

<!-- javascript section-->
<script>
//import js modules section
import store from "../../../../../store/TabelDinamisStoreV3.js";

//local registration for output component
export default {
	name: "FlyingMenuSelection",
	data() {
		return {
			selectedDataListCount: 0,
		};
	},
	props: ["isLoadingAnOptions", "isClearAllLocalStorage", "isChangeDataCart", "isEditSelectedData"],
	created() {},
	destroyed() {},
	mounted: function () {
		this.setSelectedDataListCount();
	},
	computed: {},
	watch: {
		isChangeDataCart: {
			handler: function (val) {
				if (val) {
					this.setSelectedDataListCount();
					this.$emit("update:isChangeDataCart", false);
				}
			},
			immediate: true,
		},
	},
	methods: {
		clearAllSelectionOptionsCache() {
			window.scrollTo({ top: 0, behavior: "smooth" });
			setTimeout(
				function () {
					store.clearAllSelectionLocalStorage();
					this.$emit("update:isClearAllLocalStorage", true);
				}.bind(this),
				200
			);
		},
		setSelectedDataListCount() {
			if (
				store.getSelectedDataListLocalStorageByCurrentUsername() !=
				null
			) {
				this.selectedDataListCount =
					store.getSelectedDataListLocalStorageByCurrentUsername()[0].items.length;
			} else {
				this.selectedDataListCount = -1;
			}
		},
	},
	components: {},
};
</script>

<!-- css section-->
<style lang="scss" scoped>
@import "src/assets/scss/_table-dinamis";

.selected-data-list-count {
	min-width: 24px;
	min-height: 24px;
	color: #ffffff;
	font-weight: bolder;
	background-color: rgb(239, 20, 74);
	border: 1.5px solid #ffffff;
	border-radius: 20px;
	position: absolute;
	top: 0px;
	left: 45px;
	padding: 0px 4px;
}
</style>

<!-- author: m.hanif.fahyuananto-->
<!-- version 3.0.0 -->
<!-- created on 22-06-2022 -->
